import React from "react";
import GreenWavesSvg from "@/assets/img/green-wave.svg";
import { Box, BoxProps, Image, ImageProps } from "@mantine/core";
import WaveAnimation from "./WaveAnimation";

export const GreenWaves = (props: BoxProps) => {
	return (
		<Box pos="absolute" bottom={0} right={0} w="max(60vw, 800px)" h="auto" {...props}>
			<WaveAnimation />
		</Box>
	)
}